module.exports = __webpack_public_path__ + "img/musikquiz.7bf971d4.jpg";